<div
  class="patient-card {{ size }}"
  [ngClass]="isActive ? 'active' : 'not-active'"
>
  <!-- <mat-icon *ngIf="size === 'big'" class="delete-icon" (click)="toggleConfirmationPanel()"
  >delete</mat-icon
  > -->

  <div class="name-and-contacts">
    <div class="patient-name" (click)="navigateToPatientPage()">
      <span>{{ patientName }}</span>
      <span>{{ patientSurname }}</span>
    </div>
    @if (!isActive) {
      <div class="ball not-active-ball">
        @if (!isActive) {
          <span class="ball-text">Non Attivo</span>
        }
      </div>
    }
  </div>
  @if (size === "big") {
    <section class="bottom-section">
      <div class="next-event">
        <app-button
          [icon]="'event'"
          [color]="'light-blue'"
          [size]="'icon-small'"
          [disabled]="'disabled'"
        ></app-button>
        @if (!today) {
          <span>
            {{
              interviewDate && interviewDate !== ""
                ? interviewDate
                : "Nessun appuntamento in programma"
            }}</span
          >
        }
        @if (today) {
          <span>{{ interviewTime }}</span>
        }
      </div>
      <div class="next-event">
        <app-button
          [icon]="'call'"
          [color]="'light-blue'"
          [size]="'icon-small'"
          [disabled]="'disabled'"
        ></app-button>
        <span>{{ mobile !== "" ? mobile : "Nessun numero salvato" }}</span>
      </div>
      <div class="next-event">
        <app-button
          [icon]="'mail'"
          [color]="'light-blue'"
          [size]="'icon-small'"
          [disabled]="'disabled'"
        ></app-button>
        <span>{{ email !== "" ? email : "Nessuna email salvata" }}</span>
      </div>
    </section>
  }
</div>

@if (showConfirmationPanel) {
  <app-confirmation-panel
    [title]="'Sei davvero sicuro di voler cancellare questo paziente?'"
    (cancel)="toggleConfirmationPanel()"
    (confirm)="deletePatient()"
  ></app-confirmation-panel>
}
